export interface Promo {
    active: boolean,
    ends: string
}

const promo: Promo = {
    active: false,
    ends: "October 15th"
};

export default promo;



// WEBPACK FOOTER //
// ./src/components/Promo.ts